var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { staticClass: "d-flex align-items-center text-center mt-4" },
    [
      _c(
        "div",
        { staticClass: "w-100" },
        [
          _c("v-card-title", { staticClass: "card-title" }, [
            _vm._v(" Acceso al sistema "),
          ]),
          _c("v-card-text", { staticClass: "text-left px-6 pb-6" }, [
            _c(
              "div",
              { staticClass: "d-flex align-center flex-wrap" },
              [
                _c(
                  "v-chip",
                  {
                    staticClass: "mr-3",
                    attrs: {
                      small: "",
                      color: _vm.status.color,
                      "text-color": _vm.status.text_color,
                    },
                  },
                  [_vm._v(_vm._s(_vm.status.name))]
                ),
                _vm.legajo.access
                  ? _c("span", [
                      _vm._v(" Usuario: "),
                      _c("b", [_vm._v(_vm._s(_vm.legajo.access.email))]),
                      _vm.legajo.access.last_login
                        ? _c("span", { staticClass: "grey--text" }, [
                            _vm._v(
                              " · Último ingreso " +
                                _vm._s(
                                  _vm.formatDateTime(
                                    _vm.legajo.access.last_login
                                  )
                                )
                            ),
                          ])
                        : _vm._e(),
                    ])
                  : _c("span", { staticClass: "grey--text" }, [
                      _vm._v(
                        "El empleado todavía no puede entrar al sistema para ver y firmar sus recibos."
                      ),
                    ]),
              ],
              1
            ),
            !_vm.legajo.access
              ? _c("p", { staticClass: "grey--text mt-3 mb-0" }, [
                  _vm._v(
                    " El acceso se crea automáticamente al guardar el legajo con un email: el usuario es el email y la contraseña inicial es su número de documento (la cambia en el primer ingreso). Si no se pudo crear (por ejemplo, el email ya está en uso), puede crearlo a mano. "
                  ),
                ])
              : _vm._e(),
            _c(
              "div",
              { staticClass: "mt-4" },
              [
                !_vm.legajo.access
                  ? _c(
                      "v-btn",
                      {
                        attrs: {
                          small: "",
                          color: "primary",
                          disabled:
                            !_vm.legajo.email || !!_vm.legajo.finish_date,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.openPassword(false)
                          },
                        },
                      },
                      [_vm._v("Crear acceso")]
                    )
                  : [
                      _c(
                        "v-btn",
                        {
                          staticClass: "mr-2",
                          attrs: { small: "", outlined: "", color: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.openPassword(true)
                            },
                          },
                        },
                        [_vm._v("Blanquear contraseña")]
                      ),
                      _vm.legajo.access.enable
                        ? _c(
                            "v-btn",
                            {
                              attrs: {
                                small: "",
                                outlined: "",
                                color: "red",
                                loading: _vm.loading,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.setEnabled(false)
                                },
                              },
                            },
                            [_vm._v("Deshabilitar acceso")]
                          )
                        : _c(
                            "v-btn",
                            {
                              attrs: {
                                small: "",
                                outlined: "",
                                color: "green",
                                loading: _vm.loading,
                                disabled: !!_vm.legajo.finish_date,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.setEnabled(true)
                                },
                              },
                            },
                            [_vm._v("Habilitar acceso")]
                          ),
                    ],
              ],
              2
            ),
          ]),
        ],
        1
      ),
      _c("ModalAccessPassword", {
        attrs: {
          dialog: _vm.dialog_password,
          legajo: _vm.legajo,
          reset: _vm.reset_password,
        },
        on: {
          updateDialog: (value) => (_vm.dialog_password = value),
          saved: _vm.onSaved,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }